import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '@src/service/axios';
import { toast } from 'react-toastify';
import queryString from 'query-string';

// Loader Components
import showLoader from '@components/loader';

export const getAllRoadDetails = createAsyncThunk('satelliteViewSlice/getAllRoadDetails', async (data) => {
    try {
        const query = queryString.stringify(data);
        let response = await axios.get('/all-road-details' + `?${query}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        return Promise.resolve(response.data.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getTollDetails = createAsyncThunk('satelliteViewSlice/getTollDetails', async (data) => {
    try {
        let response = await axios.post('/dashboard/toll-detail', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        return Promise.resolve(response.data.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getLayerDetails = createAsyncThunk('satelliteViewSlice/getLayerDetails', async (data) => {
    try {
        let response = await axios.post('/dashboard/emphora-layer-detail', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        return Promise.resolve(response.data.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const satelliteViewSlice = createSlice({
    name: 'satelliteViewSlice',
    initialState: {
        data: {}
    },

    extraReducers: (builder) => {
        builder.addCase(getAllRoadDetails.fulfilled, (state, action) => {
            state.allRoadData = action.payload;
            return;
        });
    }
});

export default satelliteViewSlice.reducer;
